<template>
  <FriedModal :blur-background="true" :closable="false">
    <template #header>
      <FriedModalHeader :header="$t('entity-changed-modal-title')" />
    </template>
    <FriedParagraph>
      {{ $t('entity-changed-modal-description') }}
    </FriedParagraph>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton data-external="entity-switched-refresh-button" @click="$emit('reload')">
          {{ $t('Refresh') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['reload'],
});
</script>
